import React, { useState } from 'react';
import { TextField, InputAdornment, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import {
  ConstructFilter,
  AddFilter,
  UpdateFilter,
  IsFilterActive,
  RemoveFiltersByName,
  filters,
} from '../../signals/filterService';

export default function FilterNumberInput({
  label,
  filterName,
  filterTag,
  prefix,
}) {
  const [number, setNumber] = useState('');
  const [canApply, setCanApply] = useState(false);
  const activeFilter = filters.value.find(
    (filter) => filter.name === filterName && filter.property === filterTag
  );
  const displayValue = canApply ? number : activeFilter?.value ?? '';
  const startAdornment = prefix && (
    <InputAdornment position="start">{prefix}</InputAdornment>
  );

  const handleChange = (event) => {
    setCanApply(true);
    const val = event.target.value >= 0 ? event.target.value : 0;
    setNumber(val);
  };

  const applyChange = () => {
    setCanApply(false);
    const filter = ConstructFilter(filterName, filterTag, number);
    if (filter.value === '' || filter.value === '0') {
      RemoveFiltersByName(filter.name);
      if (
        filter &&
        filterName === filter.name &&
        filterTag === filter.parameter
      )
        setNumber('');
    } else {
      if (IsFilterActive(filter)) {
        UpdateFilter(filter);
      } else {
        AddFilter(filter);
      }
    }
  };

  return (
    <div>
      <TextField
        style={{ background: 'white', borderRadius: 5, color: 'white' }}
        type="number"
        InputLabelProps={{
          shrink: true,
        }}
        label={label}
        value={displayValue}
        onChange={handleChange}
        variant="filled"
        InputProps={{
          startAdornment: startAdornment,
        }}
      />
      <Button
        style={{ color: 'white' }}
        size="small"
        disabled={!canApply}
        onClick={applyChange}
        aria-label="apply"
      >
        Apply
      </Button>
    </div>
  );
}

FilterNumberInput.propTypes = {
  label: PropTypes.string.isRequired,
  filterName: PropTypes.string.isRequired,
  filterTag: PropTypes.string.isRequired,
};
